import './css/variables.css';
import './css/base.css';
import './css/glass-components.css';
import './css/animations.css';
import './css/sections.css';
import './css/brand-theme.css';
import './css/hero.css';

import { ScrollAnimationEngine } from './js/animations/scroll-engine.js';
import { InteractiveWidgets } from './js/components/interactive-widgets.js';
import { initContactForm, showToast } from './js/contact.js';
import { saveNewsletterSubscriber } from './js/firebase.js';
import './js/theme.js';

// Global error listener for monitoring & graceful diagnostics
window.addEventListener('error', (event) => {
  console.warn('[Wah IT Services Telemetry] Client Runtime Event:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    time: new Date().toISOString()
  });
});

document.addEventListener('DOMContentLoaded', () => {
  // Initialize GSAP & Lenis Smooth Scroll Engine
  new ScrollAnimationEngine();

  // Initialize Interactive Widgets (ROI Calculator, Terminal, 3D Tilts, App Simulator)
  new InteractiveWidgets();

  // Initialize Contact Form with Validation, Loading States & Toasts
  initContactForm();

  // Initialize Newsletter Subscription handler (Firestore connected)
  const newsletterForm = document.getElementById('newsletter-form');
  const newsletterInput = document.getElementById('newsletter-email');
  const newsletterBtn = document.getElementById('newsletter-btn');

  if (newsletterForm && newsletterInput) {
    newsletterForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = newsletterInput.value.trim();
      if (!email || !email.includes('@')) {
        showToast('Please enter a valid email address.', 'error');
        return;
      }

      if (newsletterBtn) newsletterBtn.disabled = true;
      try {
        await saveNewsletterSubscriber(email);
        newsletterForm.reset();
        showToast('Subscribed! You will receive our bi-weekly Wah IT tech briefings.', 'success');
      } catch (err) {
        showToast('Subscription was not saved. Please try again.', 'error');
      } finally {
        if (newsletterBtn) newsletterBtn.disabled = false;
      }
    });
  }

  // Mobile navigation menu toggle and auto-close on link click
  const mobileToggle = document.getElementById('mobile-toggle');
  const navMenu = document.getElementById('nav-menu');
  if (mobileToggle && navMenu) {
    mobileToggle.addEventListener('click', () => {
      navMenu.classList.toggle('active');
      mobileToggle.setAttribute('aria-expanded', String(navMenu.classList.contains('active')));
    });

    // Auto-close menu when clicking any nav anchor on mobile
    navMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        navMenu.classList.remove('active');
        mobileToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Navbar dynamic floating animation on scroll
  const navbar = document.getElementById('navbar');
  const consultationLink = document.querySelector('.scroll-consultation');
  const portfolioLink = document.querySelector('.scroll-portfolio');
  const heroConsultationLink = document.querySelector('.hero-buttons a[href="#contact"]');
  const updateNavbarState = () => {
    if (!navbar) return;
    if (consultationLink && heroConsultationLink) {
      consultationLink.hidden = heroConsultationLink.getBoundingClientRect().bottom > navbar.getBoundingClientRect().bottom;
      if (portfolioLink) portfolioLink.hidden = consultationLink.hidden;
    }
    if (window.scrollY > 120) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', updateNavbarState, { passive: true });
  window.addEventListener('resize', updateNavbarState);
  const navbarLayoutObserver = new ResizeObserver(updateNavbarState);
  navbarLayoutObserver.observe(navbar);
  if (heroConsultationLink) navbarLayoutObserver.observe(heroConsultationLink);
  document.fonts.ready.then(updateNavbarState);
  updateNavbarState();

  // Active Navigation Scroll Spy
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.nav-menu .nav-link');

  const updateActiveNav = () => {
    let currentId = '';
    const scrollPosition = window.scrollY + 200;

    sections.forEach((section) => {
      const top = section.offsetTop;
      const height = section.offsetHeight;
      if (scrollPosition >= top && scrollPosition < top + height) {
        currentId = section.getAttribute('id');
      }
    });

    if (currentId) {
      navLinks.forEach((link) => {
        const href = link.getAttribute('href');
        if (href === `#${currentId}`) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    }
  };

  window.addEventListener('scroll', updateActiveNav, { passive: true });
});
